<template>
  <modal-card
    title="Send Email"
    fixed
    padding
    :full="contactUnsubscribed"
    :loading="!messagesSchemasLoaded"
    class="email-modal"
    @close="$emit('close')"
  >
    <template v-if="contactUnsubscribed">
      <v-alert type="info"> This contact is unsubscribed from emails </v-alert>
    </template>

    <template v-else>
      <v-form ref="form">
        <v-row class="mb-1 mt-1">
          <v-col>
            <form-field
              :schema="emailSchema.sender_id"
              field="sender_idy"
              v-model="email.sender_id"
            />
          </v-col>
          <v-col>
            <form-field
              :schema="emailSchema.template_id"
              field="template_id"
              v-model="email.template_id"
            />
          </v-col>
        </v-row>
        <v-text-field
          label="Subject"
          v-model="email.subject"
          :rules="[rules.required]"
          class="mb-4"
          autofocus
        />

        <form-field
          :schema="messageFieldSchema"
          v-model="email.body"
          class="mb-4"
        />
      </v-form>

      <template slot="actions">
        <v-btn color="secondary" @click="toggleModal('PreviewModal')">
          Preview
        </v-btn>
        <v-btn
          color="appMain"
          class="ml-4"
          @click="toggleModal('SendTestModal')"
        >
          Send Test
        </v-btn>
        <v-btn color="primary" class="appMain--text ml-4" @click="sendEmail()">
          Send
        </v-btn>
      </template>
    </template>

    <v-dialog
      content-class="fixed-height-lg"
      max-width="680"
      :value="!!currentModal"
      @input="toggleModal(null)"
    >
      <component :is="currentModal" :email="email" @close="toggleModal(null)" />
    </v-dialog>
  </modal-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import FormField from '@/components/formFields/FormField';
import EmailPreviewModal from '../chat/modals/EmailPreviewModal';
import EmailSendTestModal from '../chat/modals/EmailSendTestModal';

import validationRules from '@/lib/validationRules';

export default {
  name: 'CreateEmailModal',
  components: {
    FormField,
    EmailPreviewModal,
    EmailSendTestModal,
  },
  props: {
    typeId: String,
    type: String,
    contactUnsubscribed: Boolean,
    group: {},
  },
  computed: {
    ...mapGetters(['messageSchema', 'messagesSchemasLoaded']),
    emailSchema() {
      return this.messageSchema('email') || { templated_id: {} };
    },
    messageFieldSchema() {
      return { type: 'Html', validators: ['required'], field: 'body' };
    },
  },
  data() {
    return {
      currentModal: null,
      email: {
        body: '',
        class: 'email',
        reply_id: '',
        sender_id: '',
        subject: '',
        template_id: '',
        type: '', // contact/bookmark
        type_id: '', // contactId/bookmarkId
      },
      rules: {
        required: (v) => validationRules.checkRequired(v) || '',
      },
    };
  },
  methods: {
    ...mapActions(['createMessage', 'loadMessagesSchemas']),
    isValid() {
      return this.$refs.form.validate();
    },

    toggleModal(type) {
      if (!type) {
        this.currentModal = null;
        return;
      }

      if (!this.isValid()) return;
      this.currentModal = `Email${type}`;
    },

    showConfirmation() {
      this.openConfirmationModal({
        title: 'Group message confirmation',
        text: 'Are you sure you want to send this message?<br> This will send a message to everyone in this group with the necessary contact info.',
        onConfirm: () => {
          this.sendEmail(true);
        },
      });
    },

    sendEmail(confirmed) {
      if (!this.isValid()) return;

      if (!confirmed && this.type === 'bookmark') {
        this.showConfirmation();
        return;
      }

      this.email.type_id = this.typeId;
      this.email.type = this.type;

      this.createMessage(this.email).then(() => {
        this.$emit('close');
      });
    },
  },
  mounted() {
    this.loadMessagesSchemas();
  },
};
</script>

<style lang="less">
.fixed-height-lg {
  overflow: hidden;
}

.email-modal.v-card {
  height: 100%;
  background-color: var(--v-lightGray-base) !important;
  display: flex;
  flex-direction: column;
  max-height: 100%;

  .v-card__text {
    height: 100%;
    overflow: auto;
  }

  .v-form {
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;

    & > div {
      flex: none;

      &.form-group {
        flex: 1;
        height: calc(100% - 170px);
        border-bottom: 2px solid #d5d7da;

        & > div {
          height: 100%;
        }

        .quill-editor.html-field {
          height: 100%;
        }

        .ql-container.ql-snow {
          flex: 1;
          overflow: auto;

          .ql-editor.ql-blank {
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
